import axios from "axios";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { Client } from '../../Models/Client/ClientModels'
import { errorService } from "../Error/ErrorService";
import { IdentifiantService } from "../Connexion/IdentifiantService";

export function ClientService(){

  return{
    //obtention d'un client avec identifiant
    async getClient(id:number|undefined, token:any) : Promise<Client>{
      if(!id){
        throw new Error('ID du client non défini')
      }
      let client : Client = {id:0, nom:'', adresse:'', 
        numeroClient:'', email:'', magasins:[], identifiants:[], actif:false}
      try {
            const response = await axios.get(`${URLAPI}client/`+id, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":"application/ld+json"
              },
            })
            const data = response.data['hydra:member'] //valeurs retournés par l'API
            const [identifiants] = await Promise.all([
              IdentifiantService().getIdentifiantsFromUrlsToPromiseToClient(data[0]['identifiants'],token)
            ]);
            // console.log('data Client: ',data)
            // return new Client(data[0]['id'],data[0]['nom'],data[0]['adresse'],data[0]['numeroClient'],data[0]['email'],[]);
            client = {
              id:data[0]['id'], 
              nom:data[0]['nom'], 
              adresse:data[0]['adresse'], 
              numeroClient:data[0]['numeroClient'], 
              email:data[0]['email'], 
              magasins:data[0]['magasins'],
              identifiants:identifiants,
              actif:true
            }
            return client;
          } catch (error) {
            errorService().handleError('Erreur lors du getClient', error)
            return client;
          }
    },

    //Tous les clients disponibles pour administration
    async getClientsForAdmin (token:any) : Promise<Client[]>{
      let clients : Client[] = [];
      try {
          const response = await axios.get(`${URLAPI}clients`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":"application/ld+json"
            },
          })
          const data = response.data['hydra:member'] //valeurs retournés par l'API
          for(const element of data){
            clients.push({
              '@id':element['@id'],
              id:element['id'], 
              nom:element['nom'], 
              adresse:element['adresse'], 
              numeroClient:element['numeroClient'],
              email:element['email'], 
              magasins:element['magasins'],
              identifiants:[],
            })
          }

          const identifiants = await IdentifiantService().getIdentifiants(token);

          for(let client of clients){
            const idsClient = identifiants.filter(id=>id.clients?.find(clId=>clId["@id"]===client["@id"]));
            client.identifiants = idsClient;
          }

        } catch (error) {
          errorService().handleError('Erreur lors du getClientsForAdmin', error)
          return [];
        }
        return clients;
    },

    //Réutilisation de la méthode getClients précédente mais adapaté au token d'unutilisateur pour n'obtenir les données que d'un seul client : l'utilisateur
    async getClientForMonCompte(token:any, admin?:boolean) : Promise<Client>{
      if(admin)return {id:0, nom:'', adresse:'', numeroClient:'', email:'', magasins:[], actif:false, identifiants:[]}
      try {
            const response = await axios.get(`${URLAPI}clients`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":"application/ld+json"
              },
            })
            const data = response.data['hydra:member'] //valeurs retournés par l'API
            if(data.length>1){
              return {id:0, nom:'Admin', adresse:'', 
              numeroClient:'', email:'', magasins:[], actif:false, identifiants:[]}
            }
            // console.log('data Client: ',data)
            // return new Client(data[0]['id'],data[0]['nom'],data[0]['adresse'],data[0]['numeroClient'],data[0]['email'],[]);
            let client : Client = {
              id:data[0]['id'], 
              nom:data[0]['nom'], 
              adresse:data[0]['adresse'], 
              numeroClient:data[0]['numeroClient'], 
              magasins:data[0]['magasins'],
              email:data[0]['email'], 
              identifiants:data[0]['identifiants'], 
              actif:true
            }
            return client;
          } catch (error) {
            errorService().handleError('Erreur lors du getClient', error)
            let client : Client = {id:0, nom:'', adresse:'', 
              numeroClient:'', email:'', magasins:[], actif:false, identifiants:[]}
            return client;
          }
    },

    /**
     * Cette méthode permet de renvoyer un objet Client, rataché à un magasin, via une URL.
     * Pour éviter toute boucle infini via la relation entre un client et son/ses magasin(s),
     * il est préférable de ne pas enregistrer la valeur lié à un client, ni de la transformer en objet Client. 
     * Donc celle-ci restera un objet Client|undefined, qui ici sera undefined. (Modification possible à l'avenir).
     * Toutes les données liés au Client sont incluses dans cette méthode
     * 
     * Si vous souhaitez accèder au magasin à partir de l'objet magasin, alors employez la méthode ???
     */
    async getClientFromUrlToPromiseToMagasinAdmin(url:string, token:string){
      try {
        const response = await axios.get(`${URL_MIDIS+url}`, {
          headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];
        if(data.length>0){
          const [identifiants] = await Promise.all([
            IdentifiantService().getIdentifiantsFromUrlsToPromiseToClient(data[0]['identifiants'], token),
          ]);
          return {
            id:data[0]['id'], 
            nom:data[0]['nom'], 
            adresse:data[0]['adresse'], 
            numeroClient:data[0]['numeroClient'], 
            actif:true,
            identifiants:identifiants
          }
        }
      } catch (error) {
        errorService().handleError('Erreur lors du getClientFromUrlToPromiseToMagasinAdmin', error)
        return;
      }
    },

    /**
     * Cette méthode permet de renvoyer un objet Client, rataché à un magasin, via une URL.
     * Pour éviter toute boucle infini via la relation entre un client et son/ses magasin(s),
     * il est préférable de ne pas enregistrer la valeur lié à un client, ni de la transformer en objet Client. 
     * Donc celle-ci restera un objet Client|undefined, qui ici sera undefined. (Modification possible à l'avenir).
     * Toutes les données liés au Client ne sont pas incluses dans cette méthode (données liés aux tables externes ou non necessaires)
     * 
     */
    async getClientFromUrlWithoutForeignKeysData(url:string, token:string){
      try {
        const response = await axios.get(`${URL_MIDIS+url}`, {
          headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type":"application/ld+json"
          },
        });
        const data = response.data['hydra:member'];

        let client : Client = {
          id:data[0]['id'], 
          nom:data[0]['nom'], 
          adresse:data[0]['adresse'], 
          numeroClient:data[0]['numeroClient'], 
          magasins:data[0]['magasins'],
          email:data[0]['email'], 
          actif:data[0]['actif'],
          identifiants:data[0]['identifiants'],
        }

        return client;

      } catch (error) {
        errorService().handleError('Erreur lors du getClient', error)
        let client : Client = {id:0, nom:'', adresse:'', magasins:[],
          numeroClient:'', email:'', actif:false, identifiants:[]}
        return client;
      }
    },

    /**
     * Obtention de la liste des clients
     * toutes les données ne sont pas exploités 
     * @param token 
     * @returns 
     */
    async getClientsForEditAddMagasinAdmin(token:string){
      try {
        const response = await axios.get(`${URLAPI+'clients'}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type":"application/ld+json"
            },
        });
        const data = response.data['hydra:member'];
        let clients:Client[]=[]
        for(const client of data){
            clients.push({
              id: client['id'],
              nom: client['nom'],
              adresse:client['adresse'],
              magasins:client['magasins'],
              numeroClient: client['numeroClient'],
              actif:true,
              identifiants:client['identifiants']
          })
        }
        return clients;
      } catch (error) {
          errorService().handleError('Erreur lors du getPacksForEditAddMagasinsAdmin', error);
          return []
      }
    },

    async deleteClient(id:number, token:any){
      const response = await axios.delete(
        `${URLAPI}client/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.status;
    }

  }

}
